module.exports = __webpack_public_path__ + "img/speech_bubble.140b0840.png";